import { render, staticRenderFns } from "./CompetitionsReportConfirmation.vue?vue&type=template&id=4443f158"
import script from "./CompetitionsReportConfirmation.vue?vue&type=script&lang=ts"
export * from "./CompetitionsReportConfirmation.vue?vue&type=script&lang=ts"
import style0 from "./CompetitionsReportConfirmation.vue?vue&type=style&index=0&id=4443f158&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports